module.exports = __webpack_public_path__ + "img/signup-filled.6482b061.svg";